//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.NeprideleneListPage.ts               </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-12-30                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class NeprideleneListPage extends GContentBase<PodDokSpisListBasePage> 
    {
        model: Wfl.Interface.GNeprideleneFilterDto;

        onContentReady()
        {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPridelit(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionOpravaElPodani(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionVratitPoste(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionStornovat(this));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all", 
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dspreo" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            this.gridSearchColumns = ["*", "dat_zmena", "dat_pod"];
            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni);
        }

        CreateFilterForms()
        {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); 
            filterForm.addSection()
                .addField("gdatecombobox", {
                    name: "DatumField",
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });

            filterForm.addRow({ label: "" }).addField("gradio", { //RC 26285307 : Výpůjčka
                name: "FiltrDleDatumu", itemClass: "",  //RC 26285666 : Typ převzetí
                initialValue: this.model.FiltrDleDatumu,
                radios: [
                    { value: Wfl.Interface.TypFiltrDleDatumu.Podani, label: 'jres:31950068' }, //RC 26285305 : internímu subjektu
                    { value: Wfl.Interface.TypFiltrDleDatumu.Zmeny, label: 'jres:31950069' }, //RC 26285306 : externímu subjektu
                ],
                change: function (event, input) {
                    //if (input.value) {
                    //    if (that.defaultForm) {
                    //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                    //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                    //    }
                    //}
                }
            })
            filterForm.addSection()
                .addRow({ layoutDescriptor: "w-6" }).addField("gcheck", { name: "Vlastni", label: "jres:23900106", initialValue: this.model.Vlastni }) //RC 23900106 : Vlastní
                .addRow({ layoutDescriptor: "w-6" }).addField("gcheck", { name: "VcetneOdeslanych", label: "jres:23900108", initialValue: this.model.VcetneOdeslanych }) //RC 23900108 : Včetně odeslaných
                .addRow({ layoutDescriptor: "w-6" }).addField("gcheck", { name: "VcetneVyrizenych", label: "jres:23900109", initialValue: this.model.VcetneVyrizenych }) //RC 23900109 : Včetně vyřízených
                .addRow({ layoutDescriptor: "w-6" }).addField("gcheck", { name: "PouzeNovaPosta", label: "jres:23900111", initialValue: this.model.PouzeNovaPosta }); //RC 23900111 : Pouze nová pošta

            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GNeprideleneFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Wfl.Interface.SeznamNeprideleneDto[]>("LoadData", { "model": filtr })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.DokSpisListBaseAC.AfterLoadData(that); });
        }

        ReloadData()
        {
            this.LoadData(this.model);
        }
    }
};
